import { useEffect, useState } from "react";
import { NewMap } from '@synergy/maps';
import styled from "styled-components";
import { Flex } from "antd";
import Spinner from "../../Atomics/Spinner";
import useFetch from "../../../../server/useFetch";
import query from "../../../../server/constants.api";
import { t } from "i18next";
import { REACT_APP_MAPS_API_KEY } from "../../../../utils/config/envConfig";

// Define the RegisterMapComponent function component
export const RegisterMap = ({ headerheight, itemsIds, idQuery, idCenter, idZoom, mapId, configId, disableClick }) => {
    // Define state to store map items
    const [mapItems, setMapItems] = useState();

    // Fetch map configurations and map data using custom hooks
    const { data: mapData, isLoading: mapDataIsLoading, refetch: refetchMapData } = useFetch(query.path.registryMap, 'mapRegister' + idQuery, { ids: itemsIds });

    // Effect to handle map data
    useEffect(() => {
        try {
            if (mapData?.data) {
                setMapItems(mapData?.data)
            }
        } catch (error) {
            console.error('(RegisterMapComponent) Error handling maps data', error);
        }
    }, [mapData])

    // Prepare data for MapApp component
    let data = {
        configurations: mapConfiguration,
        pois: mapItems ?? null,
        center: idCenter ?? null,
        zoom: idZoom ?? null,
        mapId: mapId ?? null
    }

    // Render RegisterMapComponent
    return (
        <MapWrapper $marginTop={headerheight}>
            {mapItems && mapItems.length > 0 ? (
                !isNaN(idCenter?.lat) && !isNaN(idCenter?.lng) ? (
                    <NewMap configurations={{ ...mapConfiguration, lat: idCenter.lat, lng: idCenter.lng }} pois={mapItems}
                        disableClick={disableClick} apiKey={REACT_APP_MAPS_API_KEY} />
                ) : (
                    <ErrorMessage>{t("Invalid POI position")}</ErrorMessage>
                )
            ) : (
                <Flex align="center" justify="center" className="full-h">
                    <Spinner stroke="green-4" />
                </Flex>
            )}
        </MapWrapper>
    );
}

const mapConfiguration = {
    "heading": 0,
    "hide": ["attraction", "sports_complex", "place_of_worship", "business", "government", "medical", "park", "school"],
    "lat": 41.1621356, //41.30888749698976
    "lng": -8.6631531, //-8.649331954439138
    "mapId": "15fb961c1d0a757",
    "showGTFSRealTime": false,
    "showPOIS": true,
    "showTraffic": false,
    "showTransit": false,
    "showPolygon": false,
    "showEvents": false,
    "styles": "default",
    "tilt": 0,
    "zoom": 13,
    "hrefLink": '/home/register/registerDetail/',
    "poiType": "pois-color-by-family",
    "showLegend": false,
    "legendArray": null,
    "legendDetail": false,
    "hideEventsInfo": false
};

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const ErrorMessage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 16px;
    color: black;
    font-weight: bold;
`;

const MapWrapper = styled.div`
    height: ${props => (props.$marginTop ? 'calc(100% - ' + props.$marginTop + ')' : '100%')};
    margin-top: ${props => (props.$marginTop ? props.$marginTop : '0')};
    padding: 0;
    width: -webkit-fill-available;
`;
//#endregion